"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AccountServiceImpl {
    accountRepository;
    constructor(accountRepository) {
        this.accountRepository = accountRepository;
    }
    async listAccounts({ customer, filterByStatus, }) {
        const response = await this.accountRepository.listAccounts(customer);
        if (filterByStatus) {
            return typeof filterByStatus === 'string'
                ? response.filter((account) => account.status === filterByStatus)
                : response.filter((account) => filterByStatus.includes(account.status));
        }
        return response;
    }
    async deleteAccount({ customer, accountId, }) {
        return this.accountRepository.deleteAccount(customer, accountId);
    }
    async createAccount({ customer, account, image, }) {
        return this.accountRepository.createAccount(customer, account, image);
    }
    async updateAccount({ customer, account, image, }) {
        return this.accountRepository.updateAccount(customer, account, image);
    }
}
exports.default = AccountServiceImpl;
//# sourceMappingURL=AccountServiceImpl.js.map